import { AxiosService } from './axiosService';

class GenericPointService extends AxiosService {
    async getGenericPoints(pageSize, pageIndex, sortBy, orderBy, pointType) {
        try {
            const { data } = await this.axios.get('/genericpoints', {
                params: { pageSize, pageIndex, sortBy, orderBy, pointType },
            });
            return data;
        } catch (err) {
            if (err?.response?.status === 401) return null;
            throw err;
        }
    }

    async createGenericPoint(request) {
        try {
            const { data } = await this.axios.post('/genericpoints/create', request);
            return data;
        } catch (err) {
            if (err?.response?.status === 401) return null;
            throw err;
        }
    }

    async updateGenericPoint(request) {
        try {
            const { data } = await this.axios.put('/genericpoints/update', request);
            return data;
        } catch (err) {
            if (err?.response?.status === 401) return null;
            throw err;
        }
    }

    async deleteGenericPoint(id) {
        try {
            const { data } = await this.axios.delete(`/genericpoints/${id}`);
            return data;
        } catch (err) {
            if (err?.response?.status === 401) return null;
            throw err;
        }
    }
}

export const genericPointService = new GenericPointService();
